export default {
  baseStyle: {
    container: {
      position: 'relative',
    },
    inputContainer: {
      alignItems: 'center',
      gap: {base: 4, md: 8},
      minH: 9,
      pb: 4,
      width: '100%',
    },
    iconWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      height: {base: 6, md: 9},
      justifyContent: 'center',
      width: {base: 6, md: 9},
      sx: {
        ' svg': {
          height: '100%',
          width: '100%',
        },
      },
    },
    input: {
      background: 'transparent',
      border: 'none',
      borderRadius: '0',
      color: {base: 'grayAlpha.90', md: 'brandColors.primaryText'},
      flex: '1 1 0',
      fontSize: {base: '18px', md: '28px'},
      fontWeight: 400,
      height: 9,
      letterSpacing: {base: 0, md: '-0.32px'},
      lineHeight: {base: '1.5', md: '1.4'},
      minW: 0,
      px: 0,
      py: 1,
      _focus: {
        borderColor: 'transparent',
        boxShadow: 'none',
      },
      _hover: {
        borderColor: 'transparent',
      },
      _placeholder: {
        color: 'rgba(0, 0, 0, 0.3)',
        fontSize: {base: 'lg', md: '32px'},
        fontWeight: 'normal',
        letterSpacing: {base: 0, md: '-0.32px'},
        lineHeight: {base: '1.6', md: '1.2'},
      },
      sx: {
        '&::-webkit-search-cancel-button': {
          WebkitAppearance: 'none',
          display: 'none',
        },
        '&::-webkit-search-decoration': {
          WebkitAppearance: 'none',
        },
      },
    },
    clearButton: {
      flexShrink: 0,
      fontSize: {base: '2xs', md: 'xs'},
      fontWeight: 'semibold',
      height: 'auto',
      letterSpacing: {base: '2px', md: '2.4px'},
      lineHeight: '1.2',
      minW: 'auto',
      px: 0,
      size: 'sm',
      textTransform: 'uppercase',
      variant: 'ghost',
      color: 'brandColors.primaryDarkLinen',
      _hover: {
        bg: 'transparent',
      },
    },
    actionsContainer: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: {base: 4, md: 8},
    },
    divider: {
      borderTop: '1px solid black',
      mt: 0,
    },
    submitButton: {
      alignItems: 'center',
      color: 'brandColors.primaryText',
      display: 'flex',
      flexShrink: 0,
      h: {base: 6, md: '34px'},
      justifyContent: 'center',
      minW: {base: 6, md: '34px'},
      p: 0,
      variant: 'ghost',
      w: {base: 6, md: '34px'},
      _hover: {
        bg: 'transparent',
        opacity: 0.7,
      },
      sx: {
        ' svg': {
          height: '100%',
          width: '100%',
        },
      },
    },
    submitButtonIcon: {
      boxSize: {base: 6, md: '34px'},
    },
  },
  parts: [
    'container',
    'inputContainer',
    'iconWrapper',
    'input',
    'actionsContainer',
    'clearButton',
    'divider',
    'submitButton',
    'submitButtonIcon'
  ],
};
